import { API_BRIDGE_DOWNLOAD_URL, API_BRIDGE_EXTENSION_ID } from '../config';

export function ExtensionSetup() {
  return (
    <details className="extension-setup" open>
      <summary>Install GMV Bridge for Yahoo Finance access</summary>
      <div className="setup-grid">
        <div><span>1</span><p><a href={API_BRIDGE_DOWNLOAD_URL} download>Download GMV Bridge</a> and unzip it.</p></div>
        <div><span>2</span><p>Open <code>chrome://extensions</code> or <code>edge://extensions</code>, enable Developer mode, then choose <strong>Load unpacked</strong>.</p></div>
        <div><span>3</span><p>Select the unzipped folder, return to GoldMine Vision, and click <strong>Check Again</strong>.</p></div>
      </div>
      <p className="setup-note">Development extension ID: <code>{API_BRIDGE_EXTENSION_ID}</code>. Production builds can override this with <code>VITE_API_BRIDGE_EXTENSION_ID</code>.</p>
    </details>
  );
}
